




import { Component, Vue } from "vue-property-decorator";
import VideoRequestList from "@/components/VideoRequests/VideoRequestList.vue";
import videoRequestStore from "@/store/videoRequestStore";
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import userStore from "@/store/userStore";

@Observer
@Component({ components: { VideoRequestList } })
class VideoRequests extends Vue {
  videoRequestStore = videoRequestStore;
  dispose?: () => void;

  async mounted() {
    this.dispose = reaction(
      () => userStore.councilConfiguration?.name,
      () => {
        if (!userStore.canAccessVideoRequests()) {
          this.$router.push({ name: "Home" });
          return;
        }
        videoRequestStore.resetResults();
      },
      { fireImmediately: false }
    );
  }

  destroyed() {
    if (this.dispose) this.dispose();
    videoRequestStore.resetResults();
  }
}

export default VideoRequests;
